import "../../styles/tailwind.css"
import React, {useEffect, useState} from "react";
import {convertCartToPurchaseData, readCart, readPurchasedCart} from "../../modules/checkoutHelpers";
import {sendSlackMessageTracked} from "../../models/notifications";
import Divider from "../generalComponents/divider";

const products = [
    {
        id: 1,
        name: 'Cold Brew Bottle',
        description:
            'This glass bottle comes with a mesh insert for steeping tea or cold-brewing coffee. Pour from any angle and remove the top for easy cleaning.',
        href: '#',
        quantity: 1,
        price: '$32.00',
        imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce-images/confirmation-page-05-product-01.jpg',
        imageAlt: 'Glass bottle with black plastic pour top and mesh insert.',
    },
]

export default function OrderStatusComponent() {
    const [cartData, setCartData] = useState([])

    useEffect(() => {
        // Reads the purchased cart data

        // convertCartToPurchaseData()
        readPurchasedCart((purchasedCartData) => {
            setCartData(purchasedCartData)
            sendSlackMessageTracked(`4️⃣ Visitor is visiting the status page. Purchased cart data: ${JSON.stringify(purchasedCartData)}`)
        })
    }, []);

    return (
        <main className="bg-white px-4 pt-20 pb-24 sm:px-6 lg:px-8">
            <div className="mx-auto max-w-3xl">
                <div className="max-w-xl">
                    <p className="mt-2 text-4xl font-bold tracking-tight">Success</p>
                    <p className="mt-2 text-base text-gray-500">Follow these steps now and we'll see you there.</p>

                    <div className="mt-12 text-sm font-medium">
                        <div className="text-gray-900 text-lg">Next steps</div>
                        <div>
                            <div>1️⃣ Click below to install the app.</div>
                            <div>2️⃣ Use the application code: <span className="font-mono">AD2012</span></div>
                            <div>3️⃣ Start using Pabloo.</div>
                        </div>
                    </div>

                    <a className="mt-8 text-base font-semibold text-indigo-600 cursor-pointer" href="https://app-extension.pabloo.com/" target="_blank" >Install app <span
                        aria-hidden="true"> &rarr;</span></a>

                </div>

                <section aria-labelledby="order-heading" className="mt-10 border-t border-gray-200">
                    <h2 id="order-heading" className="sr-only">
                        Your order
                    </h2>

                    {/*<h3 className="sr-only">Items</h3>*/}
                    {/*{products.map((product) => (*/}
                    {/*    <div key={product.id} className="flex space-x-6 border-b border-gray-200 py-10" style={{*/}
                    {/*        borderTop: '1px solid #cbd5e0',*/}
                    {/*    }}>*/}
                    {/*        <div className="flex flex-auto flex-col">*/}
                    {/*            <div>*/}
                    {/*                <h4 className="font-medium underline">*/}
                    {/*                    <a href={product.href} className="text-blue-500 underline" style={{*/}
                    {/*                        textDecorationLine: "underline"*/}
                    {/*                    }}>{product.name}</a>*/}
                    {/*                </h4>*/}
                    {/*                <p className="mt-2 text-sm text-gray-600">{product.description}</p>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*))}*/}

                    {/*<div className="sm:ml-40 sm:pl-6">*/}
                    {/*    <h3 className="sr-only">Your information</h3>*/}

                    {/*    <h4 className="sr-only">Payment</h4>*/}
                    {/*    <dl className="grid grid-cols-2 gap-x-6 border-t border-gray-200 py-10 text-sm">*/}
                    {/*        <div>*/}
                    {/*            <dt className="font-medium text-gray-900">Payment method</dt>*/}
                    {/*            <dd className="mt-2 text-gray-700">*/}
                    {/*                <p>Apple Pay</p>*/}
                    {/*                <p>Mastercard</p>*/}
                    {/*                <p>*/}
                    {/*                    <span aria-hidden="true">••••</span>*/}
                    {/*                    <span className="sr-only">Ending in </span>1545*/}
                    {/*                </p>*/}
                    {/*            </dd>*/}
                    {/*        </div>*/}
                    {/*        <div>*/}
                    {/*            <dt className="font-medium text-gray-900">Shipping method</dt>*/}
                    {/*            <dd className="mt-2 text-gray-700">*/}
                    {/*                <p>DHL</p>*/}
                    {/*                <p>Takes up to 3 working days</p>*/}
                    {/*            </dd>*/}
                    {/*        </div>*/}
                    {/*    </dl>*/}

                    {/*    <h3 className="sr-only">Summary</h3>*/}

                    {/*    <dl className="space-y-6 border-t border-gray-200 pt-10 text-sm">*/}
                    {/*        <div className="flex justify-between">*/}
                    {/*            <dt className="font-medium text-gray-900">Subtotal</dt>*/}
                    {/*            <dd className="text-gray-700">$36.00</dd>*/}
                    {/*        </div>*/}
                    {/*        <div className="flex justify-between">*/}
                    {/*            <dt className="flex font-medium text-gray-900">*/}
                    {/*                Discount*/}
                    {/*                <span*/}
                    {/*                    className="ml-2 rounded-full bg-gray-200 px-2 py-0.5 text-xs text-gray-600">STUDENT50</span>*/}
                    {/*            </dt>*/}
                    {/*            <dd className="text-gray-700">-$18.00 (50%)</dd>*/}
                    {/*        </div>*/}
                    {/*        <div className="flex justify-between">*/}
                    {/*            <dt className="font-medium text-gray-900">Shipping</dt>*/}
                    {/*            <dd className="text-gray-700">$5.00</dd>*/}
                    {/*        </div>*/}
                    {/*        <div className="flex justify-between">*/}
                    {/*            <dt className="font-medium text-gray-900">Total</dt>*/}
                    {/*            <dd className="text-gray-900">$23.00</dd>*/}
                    {/*        </div>*/}
                    {/*    </dl>*/}
                    {/*</div>*/}


                </section>
            </div>
        </main>
    )
}
